export default __webpack_public_path__ + "static/media/TransportationPlanes_02.c6bf6dff.png";